import { normalizedTranslate } from '@rbilabs/components-library';
import styled, { keyframes } from 'styled-components';

import IconFacebookVerifiedBadgeBase from 'components/icons/facebook-verified-badge';
import IconInstagramVerifiedBadgeBase from 'components/icons/instagram-verified-badge';
import IconTiktokVerifiedBadgeBase from 'components/icons/tiktok-verified-badge';
import IconTwitterVerifiedBadgeBase from 'components/icons/twitter-verified-badge';
import IconYoutubeVerifiedBadgeBase from 'components/icons/youtube-verified-badge';
import MenuCardButton from 'components/menu-card-button';

const badgeIconStyles = {
  marginLeft: '4px',
  width: '13px',
};

export const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding-block-start: 16px;
  padding-block-end: 48px;
  padding-inline: 24px;

  ${Styles.desktop} {
    padding-block-end: 72px;
  }
`;

export const CarouselTitle = styled.p`
  font-size: 1rem;
  color: ${Styles.color.black};
  font-weight: 700;
  display: flex;
  align-items: center;
  margin: 0;
`;

export const AccountUsernameWrapper = styled.span`
  margin: 0 8px;
`;

export const NetworkText = styled.span`
  display: inline-block;
  margin-inline-start: 4px;
  text-transform: capitalize;
`;

export const CarouselContainer = styled.div`
  width: 100%;
  margin-block-start: 24px;
  height: 104px;

  ${Styles.desktop} {
    height: 176px;
  }

  ${Styles.desktopLarge} {
    height: 304px;
  }

  ${Styles.mobile} {
    height: 224px;
  }

  ${Styles.mobileSmall} {
    height: 104px;
  }

  ${Styles.mobileTiny} {
    height: 72px;
  }

  .slider-slide {
    cursor: default;

    img {
      object-fit: cover;
    }
  }
`;

export const PreviousButton = styled(MenuCardButton)`
  transform: rotate(180deg) translateX(50%);

  &:active {
    transform: rotate(180deg) translateX(50%) scale(0.95);
  }
`;

export const NextButton = styled(MenuCardButton)`
  transform: ${normalizedTranslate('50%')};

  &:active {
    transform: ${normalizedTranslate('50%')} scale(0.95);
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  background-color: #fff;
  border-radius: 12px;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Loading = styled.span`
  display: block;
  width: 48px;
  height: 48px;
  border: 4px solid rgba(31, 31, 31, 0.1);
  border-radius: 50%;
  border-block-start-color: ${Styles.color.primary};
  animation: ${spin} 1s ease-in-out infinite;
`;

export const ErrorMessage = styled.p`
  color: ${Styles.color.black};
`;

export const IconInstagramVerifiedBadge = styled(IconInstagramVerifiedBadgeBase)`
  ${badgeIconStyles}
`;

export const IconYoutubeVerifiedBadge = styled(IconYoutubeVerifiedBadgeBase)`
  ${badgeIconStyles}
`;

export const IconTwitterVerifiedBadge = styled(IconTwitterVerifiedBadgeBase)`
  ${badgeIconStyles}
`;

export const IconTiktokVerifiedBadge = styled(IconTiktokVerifiedBadgeBase)`
  ${badgeIconStyles}
`;

export const IconFacebookVerifiedBadge = styled(IconFacebookVerifiedBadgeBase)`
  ${badgeIconStyles}
`;
